import type { QTooltipOptions } from "./types";

export const showOnHoverAndClick: Pick<QTooltipOptions, "show" | "hide"> = {
    show: { event: "click mouseenter", delay: 0 },
    hide: { event: "mouseleave", delay: 100 },
};
